<template>
    <div class="page-box">
        <div class="banner" id="banner-c">
            <p>仿真模拟、互动体验</p>
            <div>
                <span class="front">精准模拟，</span>
                <span class="after">重塑现实场景，打造知识探索新模式</span>
            </div>
        </div>
        <div class="menu-box">
            <div class="top-box">
                <div>海量虚拟仿真 · 作品赏析</div>
                <div>结合行业特点，打造虚拟仿真全新亮点</div>
            </div>
            <div class="bottom-box">
                <div class="category-box" v-if="!showSlider">
                    <div v-for="(item,index) in catrgoryList" style="cursor: pointer;" :key="index">
                        <p :class="{active:currentCategory==item.value}" @click="changeCategory(item)">{{item.label}}</p>
                        <div class="blue-line" :class="{'active-block':currentCategory==item.value}"></div>
                    </div>
                </div>
                <el-select v-else style="margin-bottom: 2rem;" @change="search" v-model="currentCategory" placeholder="请选择所属分类">
                    <el-option
                    v-for="item in catrgoryList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-input v-model="pages.keywords" @keydown.enter.native="search" clearable @clear="search" placeholder="搜索虚拟仿真">
                    <i
                        class="iconfont icon-Magnifier el-input__icon"
                        :class="{'icon-active':pages.keywords}"
                        style="font-size: 16px;"
                        slot="suffix"
                        @click="search">
                    </i>
                </el-input>
            </div>
        </div>
        <div class="heart-course-box">
            <div class="heart-box" v-if="heartCourseList.length>0">
                <show-card :dataList="heartCourseList" type="resource" @view_course="viewCourse"></show-card>
            </div>
            <no-data v-else></no-data>
            <div v-if="pages.total>0" class="t-page-box">
                <el-pagination
                :page-size="pages.size"
                :current-page="pages.current"
                background
                :pager-count="5"
                :page-sizes="[6, 12, 18, 24]"
                :layout="$store.state.media.layout"
                @current-change="changeCurrent"
                :total="pages.total">
                </el-pagination>
            </div>
        </div>
        <contact-info></contact-info>
    </div>
</template>

<script>
import ShowCard from '../course/ShowCard.vue';
import {Category} from '@/utils/utils';
import { VirtualSoftwarePageList } from '@/api/virtualSoftware';
import { VirtualPages } from '@/utils/page';
import { filterVersion } from '@/utils/utils';
import ContactInfo from '../course/ContactInfo.vue';
    export default {
    props:['softwareType'],
     components: { ShowCard, ContactInfo },
        data(){
            return {
                /**热门课程 */
                heartCourseList:[],
                pages:{
                    keywords:'',
                    current:1,
                    size:6,
                    total:0
                },
                currentCategory:'',
                /**最新课程 */
                newCourseList:[],
                catrgoryList:[
                    {
                        label:'全部',
                        value:''
                    },
                    ...Category
                ]
            }
        },
        computed:{
            tenantId(){
                return this.$store.state.user.tenantId;
            },
            /**是否展示移动版本 */
            showSlider(){
                return this.$store.state.media.showSlider;
            }
        },
        methods:{
            filterVersion,
            /**点击查看详情 */
            viewCourse(data){
            VirtualPages.current=this.pages.current;
            VirtualPages.currentCategory=this.currentCategory;
            VirtualPages.keywords=this.pages.keywords;
             this.$router.push({
                path:'/virtualSimulation/detail',
                query:{
                    id:data.id
                }
             });
            },
            /**清空搜索 */
            clearSearch(){
                this.pages.keywords='';
                this.search();
            },
            initVPages(){
                VirtualPages.current=1;
                VirtualPages.currentCategory='';
                VirtualPages.keywords='';
            },
            changeCurrent(e){
                this.pages.current=e;
                this.virtualSoftwarePageList();
            },
            /**分页查询仿真软件 */
            virtualSoftwarePageList(){
                var params={
                    "classifyCode": this.currentCategory,
                    "tenantId":'',
                    "current": this.pages.current,
                    "resourceName": this.pages.keywords,
                    "size": this.pages.size,
                    "softwareType":this.softwareType||''
                }
                VirtualSoftwarePageList(params).then(res=>{
                    if(res.code==200){
                        this.heartCourseList=res.data.records.map(item=>{
                            return {
                                courseName:item.softwareName,
                                courseDescription:item.explainInfo,
                                resType:item.resType,
                                id:item.id,
                                studyCount:item.studyCount,
                                studyNumberCount:item.studyNumberCount,
                                collectCount:item.collectCount,
                                coverImageUrl:item.softwareCover,
                                dataType:item.dataType,
                                type:'虚拟仿真'
                            }
                        });
                        this.pages.total=res.data.total;
                    }
                })
            },
            search(){
                this.pages.current=1;
                this.virtualSoftwarePageList();
            },
            /**切换分类 */
            changeCategory(item){
                this.currentCategory=item.value;
                this.search();
            }
        },
        mounted(){
            this.pages.current=VirtualPages.current;
            this.currentCategory=VirtualPages.currentCategory||'';
            this.pages.keywords=VirtualPages.keywords;
            this.virtualSoftwarePageList();
        },
    }
</script>

<style lang="less" scoped>
/deep/.el-pager>.active {
    background-color: #387dff !important;
}
.clear-active{
    opacity: 1 !important;
}
.icon-Magnifier{
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-48%);
}
.icon-active{
    right: 20px !important;
}
.banner{
    min-height: 60rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: url(../../assets/image/virtual/virtual.png);
    background-size: 100% 100%;
    padding: 10rem 0;
    &> :nth-child(1){
        font-size: 10rem;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        color: #ffffff;
        text-shadow: 2px 2px 2px #0b77ff; 
        padding: 0 5rem;
    }
    &> :nth-child(2){
        font-size: 4rem;
        letter-spacing: 0.65rem;
        margin-top: 7rem;
        padding: 0 5rem;
    }
    .front{
        color: #0b78ff;
    }
    .after{
        color: #ffffff;
    }
}
.heart-course-box{
    position: relative;
    padding: 3rem var(--padding);
    background-image: url(../../assets/image/course/heart-bg.png);
    background-size: 100% 100%;
    min-height: 105rem;
}
.heart-box{
    padding: 6rem 0;
}
.new-box{
    padding: 3rem 0 8rem 0;
}
.p-title{
        font-weight: 700;
        font-size: 3.4rem;
        color: #151C34;
        margin-top: 6.5rem;
}
.menu-box{
    min-height: 20rem;
    background-color: #ffffff;
    padding: 6.5rem var(--padding);
    .top-box{
        display: flex;
        align-items: flex-end;
        &> :nth-child(1){
            color: #151C34;
            font-weight: 700;
            font-size: 3.4rem;
        }
        &> :nth-child(2){
            color: #565A67;
            font-size: 16px;
            margin-left: 4rem;
        }
    }
}
.category-box{
    color: #3F3F3F;
    display: flex;
    font-size: 1.8rem;
    column-gap: 6rem;
    row-gap: 1rem;
    flex-wrap: wrap;
    margin-right: 2rem;
}
.blue-line{
    height: 3px;
    width: 2rem;
    background-color: #3972FF;
    margin-top: 5px;
    margin-left: calc(50% - 1rem);
    opacity: 0;
}
.active-block{
    opacity: 1;
}
.active{
    color: #3972FF;
}
.bottom-box{
    .el-input{
        width: auto;
    }
/deep/.el-input__inner{
    width: 24rem;
    height: 4rem;
    border: 1px solid #d7d9e1;
    border-radius: 2.1rem;
    padding-left: 2.5rem;
    padding-right: 6rem;
}
}
.input{
    position: relative;
    i{
        position: absolute;
        right: 2rem;
        top: 50%;
        font-size: 1.8rem;
        transform: translateY(-50%);
        color: #000000;
        cursor: pointer;
    }
    .el-icon-circle-close{
        position: absolute;
        right: 4rem;
        top: 50%;
        font-size: 16px;
        transform: translateY(-50%);
        color: #d7dae2;
        cursor: pointer;
        transition: all 0.3s;
        opacity: 0;
    }
    .el-icon-circle-close:hover{
        color: var(--blue);
    }
}
.bottom-box{
    display: flex;
    margin-top: 6rem;
    justify-content: space-between;
    align-items: flex-start;
}
.t-page-box{
    display: flex;
    justify-content: center;
    padding: 2rem 0;
}

input:focus {
  outline: none; /* 首先移除默认的轮廓样式 */
  border: 1px solid #3972FF; /* 设置焦点时的边框颜色 */
  transition: all 0.3s;
}
input::placeholder {
    font-size: 14px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
@media screen and (max-width:750px){
    .banner{
        white-space: normal;
        min-height: auto !important;
        &> :nth-child(1){
            font-size: var(--bigTitle);
            padding: 0 var(--padding) !important;
        }
        &> :nth-child(2){
            font-size: var(--smallTitle);
            padding: 0 var(--padding) !important;
            margin-top: 2rem !important;
        }
    }
    .menu-box{
        padding-top: 4rem;
        padding-bottom: 4rem;
    }
    .top-box{
        flex-direction: column;
        align-items: center !important;
        &> :nth-child(2){
            margin-left: 0 !important;
            margin-top: 1rem;
        }
    }
    .bottom-box{
        margin-top: 3rem;
        flex-direction: column;
        /deep/.el-select{
            width: 100%;
        }
        /deep/.el-input{
            width: 100%;
        }
        /deep/.el-input__inner{
            width: 100%;
        }
    }
}
</style>